<template>
    <div class="financial_management padding-20 bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
            <el-tab-pane label="全部记录" name="first">
                <AllBills :orderListData="orderListData"></AllBills>
            </el-tab-pane>
            <el-tab-pane label="支出记录" name="second">
                <SpendingRecords :orderListData="orderListData"></SpendingRecords>
            </el-tab-pane>
            <el-tab-pane label="收入记录" name="third">
                <IncomeRecords :orderListData="orderListData"></IncomeRecords>
            </el-tab-pane>
            <el-tab-pane label="提现记录" name="fourth">
                <WithdrawalRecords :data="data"></WithdrawalRecords>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {findUserOrderList, withdrawList} from 'api/materialMgtApi'
import AllBills from 'views/orderMgt/finance/subTab/AllBills'
import SpendingRecords from 'views/orderMgt/finance/subTab/SpendingRecords'
import IncomeRecords from 'views/orderMgt/finance/subTab/IncomeRecords'
import WithdrawalRecords from 'views/orderMgt/finance/subTab/WithdrawalRecords'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'FManagement',
    data() {
        return {
            activeName: 'first',
            activeName2: 'first',
            showdDetails: false,
            orderListData: {},
            data: {
                data: {
                    content: [],
                    pageinfo: {
                        rowCount: 0
                    }
                }
            }
        }
    },
    mounted() {},
    methods: {
        handleClick(tabName) {
            // this.activeName2 = tabName
            // console.log(tabName)
            // console.log(this.activeName2)
            if (tabName === this.activeName2) {
                // 点击同一个tab不做处理
            } else {
                this.activeName2 = tabName
                if (tabName === 'first') {
                    this.getFindBillToList()
                } else if (tabName === 'second') {
                    this.getSpendingRecords()
                } else if (tabName === 'third') {
                    this.getIncomeRecords()
                } else if (tabName === 'fourth') {
                    this.getWithdrawalRecords()
                }
            }
            // if (tabName === 'first') {
            //     this.getFindBillToList()
            // } else if (tabName === 'second') {
            //     this.getSpendingRecords()
            // } else if (tabName === 'third') {
            //     this.getIncomeRecords()
            // } else if (tabName === 'fourth') {
            //     this.getWithdrawalRecords()
            // }
        },
        // 获取账单列表全部记录
        getFindBillToList() {
            this.setLoading(true)
            var params = {
                moneydirect: 0
            }
            findUserOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取收入记录
        getIncomeRecords() {
            this.setLoading(true)
            var params = {
                moneydirect: 1
            }
            findUserOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取支出记录
        getSpendingRecords() {
            this.setLoading(true)
            var params = {
                moneydirect: 2
            }
            findUserOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取提现记录
        getWithdrawalRecords() {
            this.setLoading(true)
            withdrawList({
                data: {
                    page: 1,
                    pageSize: 10
                },
                success: data => {
                    this.data = data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        AllBills,
        SpendingRecords,
        IncomeRecords,
        WithdrawalRecords
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
.financial_management {
    padding-bottom: 50px;
}
</style>